import React from 'react'
import { H4 } from '../../../Heading/index'
import SmartCreate from '../../../Icon/icons/SmartCreate/index'

export interface SmartModalHeroProps {
  /** Small uppercase label rendered above the question, e.g. "Create a playlist". */
  eyebrow: string
  /** The primary heading text (e.g. "What is your desired mood?"). */
  question: string
  /** Helper text below the heading (e.g. "Pick up to 2"). Pass empty string to hide. */
  hint?: string
  /** Optional extra class for wrapper styling. */
  className?: string
}

/**
 * Eyebrow + question + hint trio used at the top of the redesigned Smart Create
 * Playlist and Vibe Line modals. The eyebrow stays constant across all sub-steps
 * of a modal (it's the modal-level label); the question + hint change per step.
 *
 * Caller is responsible for resolving language strings — this component is
 * pure presentation with no i18n / Redux dependencies.
 */
function SmartModalHero ({
  eyebrow,
  question,
  hint = '',
  className = '',
}: SmartModalHeroProps) {
  const rootClass = ['smart-modal-hero', className].filter(Boolean).join(' ')

  return (
    <div className={rootClass}>
      {/* The eyebrow is rendered ONLY when a non-empty `eyebrow` prop is
          supplied.  Callers that promote the eyebrow into a different
          surface (e.g. CreatePlaylistModal's smart-seed step renders the
          eyebrow inline next to the close button) pass an empty string
          here to suppress the in-step eyebrow without losing the
          question + hint. */}
      {eyebrow ? (
        <span className="smart-modal-hero__eyebrow">
          <span className="smart-modal-hero__eyebrow-icon" aria-hidden="true">
            <SmartCreate size={16} />
          </span>
          <span className="smart-modal-hero__eyebrow-text">{eyebrow}</span>
        </span>
      ) : null}
      <H4 className="smart-modal-hero__question">{question}</H4>
      {hint ? (
        <p className="smart-modal-hero__hint">{hint}</p>
      ) : null}
    </div>
  )
}

export default SmartModalHero
